// Shared constants for debt type codes and labels (legacy-aligned)
export const DEBT_TYPE_CODES = {
  CREDIT_CARD: { code: 'ZC', label: 'Credit card' },
  OVERDRAFT: { code: 'OD', label: 'Overdraft' },
} as const;

export type LockedCategoryKey = 'creditCards' | 'overdrafts';

export const CATEGORY_LOCKS: Record<LockedCategoryKey, { code: string; label: string }> = {
  creditCards: DEBT_TYPE_CODES.CREDIT_CARD,
  overdrafts: DEBT_TYPE_CODES.OVERDRAFT,
};



